import { z } from 'zod';

export const getUKDirectDebitResponseSchema = z.object({
  amount: z.number(),
  chargeAttemptDate: z.string(),
  status: z.enum(['PENDING', 'RETRYING']),
});
